import isEmpty from 'lodash/isEmpty';
import { USER_COHORT, ENTITLEMENT_SOURCE } from '../auth/constants';
import Pvolve from '@pvolve/sdk';

export const getUserCohort = async (onboardingReleaseDate, payload) => {
    // TODO: REMOVE FOLLOWING LOGIC AFTER JANUARY 1ST 2022
    const todayDateString = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
    const todayDate = new Date(todayDateString).getTime();
    const compareDate = new Date(onboardingReleaseDate).getTime();

    if(isEmpty(onboardingReleaseDate) || (todayDate < compareDate)) {
        return USER_COHORT.pvolve;
    }
    //-----------------------------------------------------

    const entitlementSource = payload?.tokenAttributes?.entitlement_source;
    
      if(!isEmpty(ENTITLEMENT_SOURCE[entitlementSource])) {
        return entitlementSource;
      } else {
        const whitelistResponse = await Pvolve.api.featureFlag.featureFlagByName(payload?.onboardingUsersD2C);
        const isException = whitelistResponse?.onboardingUsersD2C?.result;

        if(isException) {
          return USER_COHORT.d2c;
        } else {
          const lastEntitledAt = payload?.tokenAttributes?.entitled_at;
          const lastEntitledDate = new Date(lastEntitledAt).getTime();
          if(isEmpty(lastEntitledAt) || (lastEntitledDate < compareDate)) {
            return USER_COHORT.pvolve
          } else {
            const featureResponse = await Pvolve.api.featureFlag.featureFlagByName(payload?.onboardingD2C);
            console.log('featureResponse: ', featureResponse);
            const onboardingFeatureEnabled = featureResponse?.onboardingD2C?.result;
            return onboardingFeatureEnabled ? USER_COHORT.d2c : USER_COHORT.pvolve;
          }
        }
      }
  };

